import { MAX_LIST_VISIBLE_INDENTATION } from '../consts.js';

export function normalizeOffset(offset: number) {
  return offset < 0
    ? 0
    : offset > MAX_LIST_VISIBLE_INDENTATION
      ? MAX_LIST_VISIBLE_INDENTATION
      : offset;
}
